<template>
  <div>
    <table>
      <tr>
        <th v-for="(header, i) in headers" :key="`${header}${i}`" class="header-item">
          {{ header.header }}
        </th>
      </tr>
      <tr  :style="{background : entity.isSelected ? '#fff0ff':'#ffffff'}" v-for="(entity, index) in data" :key="`entity-${entity.stowageInstructionDetailId}`" class="table-rows" @click="rowSelect(entity)">
        <td v-for="(header, i) in headers" :key="`${header}-${i}`">
          <slot  :name="header.field" :entity="entity">{{ entity[header.field] }}</slot>
        </td>
      </tr>
      <tr>
        <td v-for="(header, i) in headers" :key="`${header}-${i}`" class="table-footer">
          <slot :name="`footer-${header.header}`" :data="data"></slot>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  name: 'Table',
  directives: {
    'custom-directive': {
      bind(el, binding) {
        //The binding object contains information about the directive
        el.style.color = binding.value || 'red';
      },
    },
  },
  model: {
    event: 'change'
  },
  props: {
    headers: {
      type: Array,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    }
  },
  methods:{
    rowSelect(e){
      this.$emit("rowSelected",e)
      this.data.filter(c=> c.stowageInstructionDetailId==e.stowageInstructionDetailId)[0].isSelected = true
    }
  }
})
</script>

<style>
table {
  border-collapse: collapse;
  width: 100%;
  table-layout: auto !important;
  word-wrap: break-word;
}

td {
   padding: 8px;
  text-align: center;
  border-bottom: 1px solid #707070;
  position: relative;
  z-index: 10;

}

.table-footer {
  font-size: 14px;
  font-weight: bold;
  border-bottom: none
}

.header-item {
  padding: 20px 10px;
  font-size: 12px;
  background-color: #EBEDF2;
  text-transform: uppercase;
  text-align: center;
}

.table-rows:nth-child(odd) {
  background-color: rgb(255, 255, 255);
}

.table-rows:nth-child(n):hover {
  background-color: rgb(201, 199, 199);
}
</style>